import {Component, OnInit} from "@angular/core";
import {DeviceViewService, LayoutVariants} from "@services";
import {environment} from "../../../../environments/environment";
import {Translations} from "@translations";

@Component({
	selector: "sim-unsupported-tablet-template",
	templateUrl: "./unsupported-tablet-template.component.html",
	styleUrls: ["./unsupported-tablet-template.component.scss"],
	standalone: false,
})
export class UnsupportedTabletTemplateComponent implements OnInit {
	T = Translations;
	LayoutVariants = LayoutVariants;
	baseHref = environment.baseHref;

	constructor(public simDeviceViewService: DeviceViewService) {}

	ngOnInit(): void {}
}
